import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BookModal = ({ book, onClose }) => {
  useEffect(() => {
    if (!book) return;
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [book, onClose]);

  return (
    <AnimatePresence>
      {book && (
        <motion.div
          key="backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            key="modal"
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 20 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            className="relative bg-white dark:bg-navy-800 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Schließen-Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 dark:bg-navy-700 hover:bg-stone-200 dark:hover:bg-stone-600 text-stone-600 dark:text-stone-300 hover:text-stone-900 dark:hover:text-white transition-colors"
              aria-label="Schließen"
            >
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>

            <div className="flex flex-col sm:flex-row gap-0">
              {/* Buchcover */}
              <div className="sm:w-48 flex-shrink-0 bg-stone-100 dark:bg-navy-700">
                <img
                  src={book.cover}
                  alt={book.title}
                  className="w-full sm:w-48 h-56 sm:h-full object-cover rounded-t-lg sm:rounded-l-lg sm:rounded-tr-none"
                />
              </div>

              {/* Inhalt */}
              <div className="p-6 sm:p-8 flex flex-col gap-4">
                <div>
                  <p className="text-amber-800 dark:text-amber-400 text-sm font-semibold uppercase tracking-widest mb-1">
                    {book.year}
                  </p>
                  <h2 className="text-2xl font-serif font-bold text-stone-900 dark:text-stone-100 leading-tight mb-1">
                    {book.title}
                  </h2>
                  <p className="text-stone-500 dark:text-stone-400 text-sm">{book.author}</p>
                </div>

                <p className="text-stone-700 dark:text-stone-300 text-sm leading-relaxed">
                  {book.description}
                </p>

                <div className="mt-auto pt-4 border-t border-stone-100 dark:border-navy-700 flex items-center justify-between">
                  <span className="text-2xl font-bold text-amber-800 dark:text-amber-400">{book.price}</span>
                  <a
                    href={`#/kontakt`}
                    onClick={onClose}
                    className="bg-brand dark:bg-amber-700 text-white text-sm px-5 py-2.5 rounded-sm hover:bg-brand-light dark:hover:bg-amber-600 transition-colors"
                  >
                    Anfragen
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BookModal;
